import { gtmTrackEvent } from 'utils/gtmService'

export const trackEvent = async (eventName, description = '', payload = {}) => {
    if (!eventName) return
    gtmTrackEvent(eventName, payload)
}
